import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import Icon from "./icon";
import useBreakpoint from "../hooks/useBreakpoint";
import { Swiper, SwiperSlide } from "swiper/react";
import LanguageContext from "../context/language";
import { HomeScreenPromptContext } from "../context/home-screen-prompt";
import useDetectSticky from "../hooks/useDetectSticky";

const IndexBar = ({ waypoints, activeWaypoint, className = "" }) => {
  const { showHomeScreenPrompt } = useContext(HomeScreenPromptContext);
  const isMobile = useBreakpoint(767);
  const [open, setOpen] = useState(true);
  const { labels } = useContext(LanguageContext);
  const waypointIndex = waypoints.findIndex((w) => w.value === activeWaypoint);
  const [isSticky, ref] = useDetectSticky(!(waypoints.length === 0), setOpen);

  // viene fatto a mano e non con useBlockScroll perché quest'ultimo fa scrollare la pagina
  // quando si apre e si chiude il menù, probabilmente perché la classe che viene aggiunta
  // fa shiftare il layout
  useEffect(() => {
    if (isSticky && open && isMobile) {
      document.body.classList.add("index-bar-scroll");
    } else {
      document.body.classList.remove("index-bar-scroll");
    }
    return () => {
      document.body.classList.remove("index-bar-scroll");
    };
  }, [isMobile, isSticky, open]);

  if (waypoints.length === 0) {
    return null;
  }

  return (
    <div
      ref={ref}
      className={classNames(
        "index-bar",
        {
          "index-bar--pwa-banner": showHomeScreenPrompt,
          "index-bar--sticky": isSticky,
        },
        className
      )}
    >
      {open && isMobile && isSticky && (
        <button
          className="index-bar__black"
          onClick={() => setOpen(false)}
          onMouseDown={() => setOpen(false)}
        ></button>
      )}
      <button
        className={classNames("index-bar__accordion", open && "index-bar__accordion--open")}
        onClick={() => {
          setOpen((current) => !current);
          // evita di tagliare il menù se è scrollato quasi del tutto
          setTimeout(() => {
            if (ref.current.getBoundingClientRect().y < 0 && isMobile) {
              ref.current.scrollIntoView();
            }
          }, 100);
        }}
      >
        <div className="index-bar__panel">
          <div className="index-bar__title">
            {activeWaypoint !== ""
              ? waypoints[waypointIndex].label
              : labels.INDEX?.toUpperCase() ?? "INDEX"}
          </div>
        </div>
        <Icon name="chevron-right" />
      </button>
      <div
        className={classNames("index-bar__swiper", {
          "index-bar__swiper--open": open,
        })}
      >
        {activeWaypoint && (
          <div className="index-bar__index index-bar__index--white">
            {labels.INDEX?.toUpperCase() ?? "INDEX"}
          </div>
        )}
        <Swiper
          spaceBetween={0}
          slidesPerView={1}
          loop={false}
          watchOverflow={true}
          enabled={false}
          breakpoints={{
            767: {
              enabled: true,
              slidesPerView: "auto",
              spaceBetween: 40,
            },
          }}
        >
          {waypoints.map((w, i) => (
            <SwiperSlide key={i}>
              <a
                className={classNames(
                  "index-bar__item",
                  i === waypointIndex && "index-bar__item--selected",
                  open && "index-bar__open"
                )}
                id={i}
                href={`#${w.value}`}
                onClick={(e) => {
                  e.preventDefault();
                  const href = e.currentTarget.getAttribute("href") || "";
                  if (href.startsWith("#")) {
                    const id = href.substring(1);
                    const target = document.getElementById(id);
                    // evita scroll erronei in mobile
                    requestAnimationFrame(() => target?.scrollIntoView({ behavior: "smooth" }));
                  }

                  if (isMobile) {
                    setOpen((current) => !current);
                  }
                }}
              >
                <div
                  className={classNames(
                    "index-bar__bold-wrapper",
                    i === waypointIndex && "index-bar__bold-wrapper--selected"
                  )}
                >
                  <div className="index-bar__title">{w.label}</div>
                </div>
                <div className="index-bar__normal-wrapper">
                  <div className="index-bar__title">{w.label}</div>
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default IndexBar;
